import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { Title } from './developers/page-components/Title';
import { Spinner } from './Spinner';
import './SectionWrapper.scss';
import { SectionControlButtons } from './SectionControlButtons';
import { PagePlaceholder } from './PagePlaceholder';

interface ISectionWrapperProps {
	sectionAdditionalClass?: string;
	sectionBodyAdditionalClass?: string;
	filterSectionAdditionalClass?: string;
	title?: string;
	children: ReactNode;
	isCardBody?: boolean;
	isEditMode?: boolean;
	setIsEditMode?: (value:boolean) => void;
	onEditClick?: () => void;
	onCancelClick?: () => void;
	loading?: boolean;
	pageLoading?: boolean;
	top?: number | string;
	left?: number | string;
	headerAdditionalBlock?: JSX.Element;
	filterSection?: JSX.Element;
	isEditBlock?: boolean;
	additionalLabel?: string;
	additionalLabelClass?: string;
	id?: string;
	showPlaceholder?: boolean;
	additionalBodyStyles?: { [key: string]: string };
}

export const SectionWrapper = (props: ISectionWrapperProps): JSX.Element => {
	const {
		sectionAdditionalClass,
		sectionBodyAdditionalClass,
		filterSectionAdditionalClass,
		title,
		isCardBody,
		isEditMode,
		setIsEditMode,
		onEditClick,
		onCancelClick,
		children,
		loading,
		pageLoading,
		top,
		left,
		headerAdditionalBlock,
		filterSection,
		isEditBlock,
		additionalLabel,
		additionalLabelClass,
		id,
		showPlaceholder,
		additionalBodyStyles = {}
	} = props;

	let mainInformation;

	if (pageLoading) {
		mainInformation = <Spinner pageLoader top={top} left={left} />;
	} else if (showPlaceholder) {
		mainInformation = <PagePlaceholder top={top} left={left} />;
	} else {
		mainInformation = children;
	}

	return (
		<div className={clsx('card', sectionAdditionalClass)} id={id}>
			{
				title && (
					<div className="card-header d-flex align-items-center justify-content-between">
						<div className="d-flex align-items-center">
							<Title title={title} additionalClass="fs-2"/>
							{
								additionalLabel && (
									<div className={clsx('text-danger ms-5 fw-bolder fs-6', additionalLabelClass)}>{additionalLabel}</div>
								)
							}
						</div>
						{
							isEditBlock && (
								<SectionControlButtons
									isEditMode={isEditMode}
									setIsEditMode={setIsEditMode}
									onCancelClick={onCancelClick}
									onSaveClick={onEditClick}
									loading={loading}
								/>
							)
						}
						{ headerAdditionalBlock && headerAdditionalBlock }
					</div>
				)
			}
			{
				filterSection && (
					<>
						<div className={clsx('card-body', filterSectionAdditionalClass)}>
							{filterSection}
						</div>
						<div className="separator" />
					</>
				)
			}
			{
				isCardBody
					? (
						<div className={clsx('card-body', sectionBodyAdditionalClass)} style={additionalBodyStyles}>
							{mainInformation}
						</div>
					)
					: mainInformation
			}
		</div>
	);
};
